var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showMap)?_c('NavButton',{attrs:{"btn-id":_vm.button.id,"image-src":_vm.button.src,"link":_vm.button.to,"label":_vm.button.name,"list":_vm.list}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }